import React, { Component } from 'react';
import { withRouter } from 'utilities';
import { useAuth } from 'auth_context';

import { Loading } from 'components';

class OrganizationInfoPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			org_data: {},
			org_id: '',
			can_edit: false,
			edited: false,
			saving: false,
			saved_successfully: false,
		};
	}
	componentDidMount() {
		const user = this.props.auth.user;

		if (!user) {
			return;
		}

		this.fetch_org_details();
	}

	componentDidUpdate(prevProps) {}

	fetch_org_details = async () => {
		this.setState({ loading: true });

		await this.get_prefills();

		const orgId = this.props.orgId || this.props.params?.orgId;
		let url = `/api/get_org_details/${orgId}/`;

		let response = await this.props.auth.authFetch(url);

		const data = await response.json();

		this.setState({ org_data: data.org, org_id: data.id, can_edit: data.can_edit, loading: false });
	};

	get_prefills = async () => {
		let response = await this.props.auth.authFetch('/api/get_prefills/');
		let data = await response.json();

		let states = [];
		let countries = [];

		for (let state of data.states) {
			states.push(<option value={state}>{state}</option>);
		}
		for (let country of data.countries) {
			countries.push(<option value={country}>{country}</option>);
		}

		this.setState({ countries: countries, states: states });
	};

	update_form_data = (field_name, value, is_public) => {
		let org_data = { ...this.state.org_data };

		if (is_public) {
			org_data[field_name].is_public = value;
		} else {
			org_data[field_name].value = value;
		}

		this.setState({ org_data: org_data, edited: true });
	};

	populate_org_fields = () => {
		let tooltip_text = `Only checked fields (Visible) below will be made available publicly on our org map.
Fields not checked (Invisible) will be hidden, and accessible only to internal dev team.`;
		let fields_jsx = [];
		let data = this.state.org_data;
		const disabled = !this.state.can_edit;
		fields_jsx.push([<div></div>]);
		fields_jsx.push([<div></div>]);
		fields_jsx.push([
			<div
				className="tooltip-wrapper-floating"
				data-tooltip={tooltip_text}
				style={{ whiteSpace: 'pre-wrap' }}
			>
				<h5 style={{ textAlign: 'center' }}>Visible to Public?</h5>
			</div>,
		]);

		for (let field_name of Object.keys(data)) {
			fields_jsx.push(
				<label className="org-detail-label" for={field_name}>
					{data[field_name].display_name}:
				</label>
			);

			if (['state', 'country'].includes(field_name)) {
				fields_jsx.push(
					<select
						className={`org-detail-select ${disabled ? 'org-detail-disabled' : ''}`}
						id={field_name}
						disabled={disabled}
						value={data[field_name].value || ''}
						onChange={e => this.update_form_data(field_name, e.target.value, false)}
					>
						{field_name === 'state' ? this.state.states : this.state.countries}
					</select>
				);
			} else if (['description'].includes(field_name)) {
				fields_jsx.push(
					<textarea
						className={`org-detail-textarea ${disabled ? 'org-detail-disabled' : ''}`}
						id={field_name}
						disabled={disabled}
						value={data[field_name].value || ''}
						onChange={e => this.update_form_data(field_name, e.target.value, false)}
					/>
				);
			} else {
				fields_jsx.push(
					<input
						className={`org-detail-input ${disabled ? 'org-detail-disabled' : ''}`}
						id={field_name}
						disabled={disabled}
						value={data[field_name].value || ''}
						onChange={e => this.update_form_data(field_name, e.target.value, false)}
					/>
				);
			}
			fields_jsx.push(
				<input
					className="org-detail-public-checkbox"
					id={`${field_name}_public`}
					type="checkbox"
					disabled={disabled}
					checked={data[field_name].is_public}
					onChange={e => this.update_form_data(field_name, e.target.checked, true)}
				/>
			);
		}

		return fields_jsx;
	};

	save_changes = async () => {
		this.setState({ saving: true });
		let url = `/api/submit_org_details/${this.state.org_id}/`;
		let response = await this.props.auth.authFetch(url, {
			method: 'POST',
			body: JSON.stringify(this.state.org_data),
			headers: { 'Content-Type': 'application/json' },
		});

		const data = await response.json();
		if (data.success) {
			this.setState({ saving: false }, this.trigger_saved_indicator);
		}
	};

	trigger_saved_indicator = () => {
		this.setState({ saved_successfully: true }, () =>
			setTimeout(() => this.setState({ saved_successfully: false }), 3500)
		);
	};

	render() {
		const { auth } = this.props;

		if (this.state.loading) {
			return <Loading loading={this.state.loading} />;
		}

		if (auth.loading) {
			return <Loading loading={this.state.loading} />;
		}

		if (!auth.user) {
			return <Loading loading={this.state.loading} />;
		}

		let button_visible = this.state.saved_successfully ? 'visible' : 'invisible';
		let saved_indicator = <h5 className={`appearing ${button_visible}`}>Changes saved successfully!</h5>;

		let fields_jsx = this.populate_org_fields();

		let save_button = [];
		if (!this.state.can_edit) {
			save_button = [];
		} else if (this.state.saving) {
			save_button = [
				<button className="org-info-save-button" onClick={this.save_changes}>
					Saving...
				</button>,
			];
		} else {
			save_button = [
				<button className="org-info-save-button" onClick={this.save_changes}>
					Save Changes
				</button>,
			];
		}

		const embedded = this.props.embedded;

		return (
			<div>
				<div className="org-info-container">
					{!embedded && <h1>Welcome {this.props.auth.user.name}!</h1>}

					<h3>
						{embedded
							? this.state.org_data?.name?.value || 'Your organization'
							: 'Here is the info we currently have for your organization:'}
					</h3>

					{!this.state.can_edit && (
						<div className="org-pending-banner">
							Your membership is pending approval. You can view your organization's info, but
							editing unlocks once an admin or co-organizer approves your request.
						</div>
					)}

					<div className="org-detail-table">{fields_jsx}</div>
					{save_button}
					{saved_indicator}
				</div>
			</div>
		);
	}
}

const OrganizationInfo = props => {
	const auth = useAuth();
	return <OrganizationInfoPage {...props} auth={auth} />;
};

export default withRouter(OrganizationInfo);
